var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.145 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7347",
    "data-name": "Group 7347",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22666",
    "data-name": "Path 22666",
    d: "M24.219,11.27H13.195a1.575,1.575,0,1,1,0-3.15H24.219a1.575,1.575,0,1,1,0,3.15Z",
    transform: "translate(11.404 7.555)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22667",
    "data-name": "Path 22667",
    d: "M8.766,14.5a1.557,1.557,0,0,1-1.113-.462L6.079,12.465A1.574,1.574,0,1,1,8.3,10.239l.462.462,3.612-3.612A1.574,1.574,0,1,1,14.6,9.315L9.879,14.039a1.573,1.573,0,0,1-1.113.462Z",
    transform: "translate(4.808 5.919)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22668",
    "data-name": "Path 22668",
    d: "M24.219,18.27H13.195a1.575,1.575,0,1,1,0-3.15H24.219a1.575,1.575,0,1,1,0,3.15Z",
    transform: "translate(11.404 15.254)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22669",
    "data-name": "Path 22669",
    d: "M8.766,21.5a1.557,1.557,0,0,1-1.113-.462L6.079,19.465A1.574,1.574,0,1,1,8.3,17.239l.462.462,3.612-3.612A1.574,1.574,0,0,1,14.6,16.315L9.879,21.039a1.573,1.573,0,0,1-1.113.462Z",
    transform: "translate(4.808 13.618)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22670",
    "data-name": "Path 22670",
    d: "M30.122,46.395h-12.6c-11.4,0-16.273-4.871-16.273-16.273v-12.6C1.25,6.121,6.121,1.25,17.523,1.25h12.6c11.4,0,16.273,4.871,16.273,16.273v12.6C46.395,41.523,41.523,46.395,30.122,46.395ZM17.523,4.4C7.843,4.4,4.4,7.843,4.4,17.523v12.6c0,9.68,3.444,13.123,13.123,13.123h12.6c9.68,0,13.123-3.444,13.123-13.123v-12.6C43.245,7.843,39.8,4.4,30.122,4.4Z",
    transform: "translate(0 0)",
    fill: "#9797bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconList);
export default __webpack_public_path__ + "static/media/TabIconList.1abbe69e5e528687a26d8e07259edd4f.svg";
export { ForwardRef as ReactComponent };